import { lookupSelector } from '~store/lookupSelector';
import { selectors as TranslationSelectors } from '~store/slices/translations';
import { selectRootState } from './root';

// Root: Slice Selectors
export const selecTranslationsState = lookupSelector(selectRootState, state => state.translations);

// Slice: Translations Selectors
export const selectTranslations = lookupSelector(selecTranslationsState, TranslationSelectors.translations);
